// extracted by mini-css-extract-plugin
module.exports = {"app":"vop_notice_detail_app__32G5b"};